export default __webpack_public_path__ + "static/marking-0a17d7126ef1a6f7990c7abe4441ac56.png";